import { h, defineComponent } from 'vue';
export const IonPage = /*@__PURE__*/ defineComponent({
    name: 'IonPage',
    props: {
        registerIonPage: { type: Function, default: () => { } }
    },
    mounted() {
        this.$props.registerIonPage(this.$refs.ionPage);
    },
    setup(_, { attrs, slots }) {
        return () => {
            return h('div', Object.assign(Object.assign({}, attrs), { ['class']: 'ion-page', ref: 'ionPage' }), slots.default && slots.default());
        };
    }
});
//# sourceMappingURL=IonPage.js.map